import { IconBase } from './IconBase'

type IconUnMuteProps = React.ComponentProps<'svg'>

export const IconUnMute = (props: IconUnMuteProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path d="M19.952 2.197a.8.8 0 0 0-.624 1.31 13.825 13.825 0 0 1 3.072 8.698c0 3.118-1.042 5.983-2.783 8.309a.8.8 0 1 0 1.281.96A15.427 15.427 0 0 0 24 12.203c0-3.666-1.29-7.043-3.425-9.7a.8.8 0 0 0-.623-.307Zm-3.922 2.32a.8.8 0 0 0-.64 1.302 10.326 10.326 0 0 1 .285 12.392.798.798 0 0 0 .462 1.27.8.8 0 0 0 .841-.344 11.935 11.935 0 0 0 2.222-6.932c0-2.778-.96-5.337-2.55-7.37a.8.8 0 0 0-.62-.318ZM8.8 5.6 5.434 8.8H2.4A2.4 2.4 0 0 0 0 11.2v1.6a2.4 2.4 0 0 0 2.4 2.4h3.034L8.8 18.4V5.6Zm2.99 1.273a.8.8 0 0 0-.588 1.36 5.726 5.726 0 0 1 1.598 3.972 5.728 5.728 0 0 1-1.295 3.632.801.801 0 0 0 .698 1.32.8.8 0 0 0 .542-.31 7.342 7.342 0 0 0 1.655-4.642 7.342 7.342 0 0 0-2.04-5.077.8.8 0 0 0-.57-.255Z" />
    </IconBase>
  )
}
